import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import {
  associateInterestWithAuthenticatedUser,
  disassociateInterestWithAuthenticatedUser,
  createAndClaimUnrecognizedInterest,
} from './restApi';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

const InterestsModalTable = () => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const newUnrecognizedInterestNotFoundInPreexistingInterests =
    !state?.interestsModal?.interests.some(interest =>
      interest.name?.toLowerCase() === state?.interestsModal?.newUnrecognizedInterestForm?.interestName?.toLowerCase()
    );

  const newUnrecognizedInterestFormHasContent =
    state?.interestsModal?.newUnrecognizedInterestForm?.interestName &&
    state?.interestsModal?.newUnrecognizedInterestForm?.interestName?.length > 0;

  const displayedInterests = [...state?.interestsModal?.interests];

  if (newUnrecognizedInterestFormHasContent && newUnrecognizedInterestNotFoundInPreexistingInterests) {
    displayedInterests.unshift({
      name: state?.interestsModal?.newUnrecognizedInterestForm?.interestName,
      claimedByAuthenticatedUser: false,
      aasmState: 'Does not exist in database',
      isInjected: true,
    });
  }

  if (displayedInterests.length === 0) {
    return null;
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Claimed By You</Th>
          <Th>State</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {displayedInterests.map(interest => (
          <Tr key={interest.id}>
            <Td>{interest.name}</Td>
            <Td>{interest.claimedByAuthenticatedUser ? 'Yes' : 'No'}</Td>
            <Td>{interest.aasmState}</Td>
            <Td>
              <ActionRow align="end">
                {interest.claimedByAuthenticatedUser && (
                  <Button
                    onClick={() => {
                      disassociateInterestWithAuthenticatedUser({
                        body: {
                          interestId: interest.id,
                          pageNumber: state?.interestsModal?.pageNumber,
                          newUnrecognizedInterestForm: state?.interestsModal?.newUnrecognizedInterestForm,
                          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Unclaim
                  </Button>
                )}
                {!interest.claimedByAuthenticatedUser && interest.isInjected && (
                  <Button
                    onClick={() => {
                      createAndClaimUnrecognizedInterest({
                        onResponse,
                        onError,
                        body: {
                          newUnrecognizedInterestForm: state?.interestsModal?.newUnrecognizedInterestForm,
                          pageNumber: state?.interestsModal?.pageNumber,
                          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
                          authenticityToken,
                        },
                      });
                    }}
                  >
                    Create And Claim
                  </Button>
                )}
                {!interest.claimedByAuthenticatedUser && !interest.isInjected && (
                  <Button
                    onClick={() => {
                      associateInterestWithAuthenticatedUser({
                        body: {
                          interestId: interest.id,
                          pageNumber: state?.interestsModal?.pageNumber,
                          newUnrecognizedInterestForm: state?.interestsModal?.newUnrecognizedInterestForm,
                          debouncedInterestNameForFuzzyFilter: state?.interestsModal?.newUnrecognizedInterestForm?.debouncedInterestNameForFuzzyFilter,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Claim
                  </Button>
                )}
              </ActionRow>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default InterestsModalTable;
